import { render, staticRenderFns } from "./ReminderPage.vue?vue&type=template&id=f90cc9da&scoped=true"
import script from "./ReminderPage.vue?vue&type=script&lang=js"
export * from "./ReminderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90cc9da",
  null
  
)

export default component.exports